import { type RouteObject } from 'react-router-dom';

import Layout from '../components/Layout';
import Overlays from '../components/Overlays';
import ErrorPage from '../pages/ErrorPage';
import SubscriptionDetail from '../pages/SubscriptionDetail';
import SubscriptionList from '../pages/SubscriptionList';

const routes: RouteObject[] = [
  {
    element: <Overlays />,
    errorElement: <ErrorPage />,
    children: [
      {
        path: '/',
        element: <Layout />,
        children: [
          {
            index: true,
            element: <SubscriptionList />,
          },
          {
            path: '/subscription/:id',
            element: <SubscriptionDetail />,
          },
        ],
      },
    ],
  },
];

export default routes;
